import { Button, Flex } from '@huspy/briks-web';
import { Image } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { imagesPath } from '@shared/css.const';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { AMPLITUDE_FEATURE_FLAGS } from '@modules/core/api/types';
import { CreditsRoute } from '../../../routes';
import creditsCTAStyles from './styles';

const { button } = creditsCTAStyles;

const CreditsCTA = () => {
  const { featureFlags } = useFeatureFlags();

  const CLIENT_HUB_CREDITS_MODULE = featureFlags?.[AMPLITUDE_FEATURE_FLAGS.CLIENT_HUB_CREDITS_MODULE];

  const { t } = useTranslation();

  const navigate = useNavigate();

  const onClick = () => {
    navigate({ to: CreditsRoute.to });
  };

  if (!CLIENT_HUB_CREDITS_MODULE) {
    return <></>;
  }

  return (
    <Button
      onClick={ onClick }
      size='md'
      variant='outline'
      className={ button }
      data-test='credits-menu'
    >
      <Flex gap={ 2 } align='center'>
        <Image
          src={ `${imagesPath}/credits.png` }
          w={ 26 }
        />
        {t('common.credits')}
      </Flex>
    </Button>
  );
};

export default CreditsCTA;
